import { useFormContext } from "react-hook-form";
import { TextField } from "@mui/material";
import { GenerateField } from "./GenerateField";

export function CityField() {
  const {
    formState: { errors },
  } = useFormContext();

  const fieldName = "city";
  const hasError = !!errors[fieldName]?.type;

  return (
    <GenerateField
      errorText="Required field"
      name={fieldName}
      rules={{
        validate: (value) => !!value?.trim(),
      }}
      render={({ field }) => (
        <TextField
          {...field}
          fullWidth
          error={hasError}
          label="City"
          variant="filled"
          inputProps={{
            maxLength: 200,
          }}
        />
      )}
    />
  );
}
